// eslint-disable-next-line import/no-named-as-default
import api from '../config/api';

export default function finishItinerary() {
  return api.post('/last-mile/v1/shipment/finish', {});
}
